import PaymentMethodSimpleForm from './PaymentMethodSimpleForm'

export default PaymentMethodSimpleForm
